// @flow
'use strict';

import * as React from 'react';
import { Col, Row } from 'react-bootstrap';
import { FormSection } from 'redux-form/immutable';

import CampoLido from '../../../common/campos_busca_estruturada/campo_lido';
import CampoSituacaoArquivo from '../../../common/campos_busca_estruturada/campo_situacao_arquivo';
import CampoCustodiado from '../../../common/campos_busca_estruturada/campo_custodiado';
import CampoSituacaoSefaz from '../../../common/campos_busca_estruturada/campo_situacao_sefaz';
import { CAMPOS_SITUACAO_SEFAZ_CFE, CAMPOS_SITUACAO_CUSTODIA_CFE } from '../../constantes';
import CampoSituacaoCustodia from '../../../common/campos_busca_estruturada/campo_situacao_custodia';

type CamposSituacoesProps = {
  suporte : bool,
}

export default function CamposSituacoes({ suporte } : CamposSituacoesProps) {
  return (
      <>
        <fieldset>
          <legend>Situações</legend>
        </fieldset>
        <Row>
          <Col sm={ 6 }>
            <FormSection name="lido">
              <CampoLido/>
            </FormSection>

            <FormSection name="situacao_sefaz">
              <CampoSituacaoSefaz campos={ CAMPOS_SITUACAO_SEFAZ_CFE }/>
            </FormSection>

            { suporte &&
                <FormSection name="situacao_custodia">
                  <CampoSituacaoCustodia campos={ CAMPOS_SITUACAO_CUSTODIA_CFE }/>
                </FormSection>
            }
          </Col>
          <Col sm={ 6 }>
            <FormSection name="custodiado">
              <CampoCustodiado/>
            </FormSection>

            <FormSection name="situacao_arquivo">
              <CampoSituacaoArquivo/>
            </FormSection>
          </Col>
        </Row>
      </>
  );
}
